import { useEffect, useSyncExternalStore } from "react";
import { subscribe, getSnapshot, start, updateEnabled } from "./automatedChatStore";

export const useAutomatedChat = () => {
    const state = useSyncExternalStore(subscribe, getSnapshot);

    useEffect(() => {
        start();
    }, []);

    return { ...state, updateEnabled };
};
